/**
 * Formats a timestamp into a readable date and time string
 * Handles null/undefined values and invalid date formats
 */
export function formatTimestamp(timestamp: string | number | null | undefined): string {
  if (!timestamp) return 'Not available';
  
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return 'Invalid timestamp';
  
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).format(date);
}
